import { FC } from 'react';
import MindyAreaChart from './MindyAreaChart';
import MindyBarChart from './MindyBarChart';
import MindyLineChart from './MindyLineChart';
import MindyPieChart from './MindyPieChart';
import MindyRadarChart from './MindyRadarChart';
import { ChartAttachment, ChartAttachmentType } from '../../pages/Chat/Chat/types';

interface ChartsI {
    attachments: ChartAttachment;
}

// data source most be like this, a list of objects to describe a
//  point/group according chart
/**
 * data = [
 *  {
 *      key1: value1,
 *      key2: value2,
 *      key3: value3,
 *  }
 * ]
 */

const Charts: FC<ChartsI> = ({ attachments }) => {
    const ChartList: Record<ChartAttachmentType, JSX.Element> = {
        LineChart: <MindyLineChart {...attachments} />,
        BarChart: <MindyBarChart {...attachments} />,
        PieChart: <MindyPieChart {...attachments} />,
        RadarChart: <MindyRadarChart {...attachments} />,
        AreaChart: <MindyAreaChart {...attachments} />,
    };
    return ChartList[attachments.chartType] || <div>Chart not found</div>;
};

export default Charts;
